export default __webpack_public_path__ + "static/media/Impact Assessment of CAVs Framework.ee6fae9c.pdf";